import Carousel from '@itseasy21/react-elastic-carousel';
import {
  Box,
  useBreakpointValue
} from '@chakra-ui/react';
import './slider.css';

export interface SliderProps {
  content: JSX.Element[];
  slidesPerView?: number;
  slidesPerMobileView?: number;
  pagination?: boolean;
  enableAutoPlay?: boolean;
  autoPlaySpeed?:  number;
  transitionMs?: number;
  itemPadding?: number;
}

export default function Slider({ content, slidesPerView = 4, slidesPerMobileView = 3, pagination = true, enableAutoPlay = false, autoPlaySpeed = 5000, transitionMs = 500, itemPadding=0 }: SliderProps) {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const itemsToShow = isMobile && slidesPerMobileView ? slidesPerMobileView : slidesPerView;
  const sliderContent = content.map((item, index: number) => (
    <Box width="100%" height="100%" key={`slider_content_${index}`}> {item} </Box>
  ));
  return (
    <Carousel itemsToShow={itemsToShow} isRTL={false} showArrows={false} pagination={pagination} enableAutoPlay={enableAutoPlay} autoPlaySpeed={autoPlaySpeed} transitionMs={transitionMs} itemPadding={[itemPadding]}>
      {sliderContent}
    </Carousel>
  );
}
